"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _recharts = require("recharts");
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "line_chart-module__container___bqsNv",
  "title": "line_chart-module__title___S8hBE",
  "capsule_title": "line_chart-module__capsule_title___j0grx line_chart-module__title___S8hBE",
  "capsule_subtitle": "line_chart-module__capsule_subtitle___kvk1D",
  "info_container": "line_chart-module__info_container___aU3oH",
  "capsule_container": "line_chart-module__capsule_container___tMtV2",
  "tooltip": "line_chart-module__tooltip___Ne4Ic",
  "tooltip_circle": "line_chart-module__tooltip_circle___BiwiL",
  "tooltip_bold": "line_chart-module__tooltip_bold___hUqch",
  "tooltip_text": "line_chart-module__tooltip_text___vk9lb",
  "tooltip_link": "line_chart-module__tooltip_link___zYaax"
};
const CHART_HEIGHT = 155;
const OFFSET = 64;
const XAXIS_FILL = '#324661';
const XAXIS_COLOR = '#9B9B9B';
const YAXIS_FILL = '#1B2F4B';
const CustomTooltip = ({
  payload
}) => {
  if (payload && payload[0]) {
    let defs = [];
    for (let each in payload) {
      const def = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        key: each,
        className: styles.tooltip_circle,
        style: {
          backgroundColor: payload[each].stroke
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.tooltip_text
      }, payload[each].name, " : ", payload[each].value));
      defs.push(def);
    }
    const tooltip = /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tooltip
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tooltip_bold
    }, payload[0].payload.name), defs);
    return tooltip;
  }
  return null;
};
class LineChart extends _react.default.Component {
  static propTypes = {
    data: T.array.isRequired,
    height: T.number,
    width: T.oneOfType([T.number, T.string]),
    xAxis: T.oneOfType([T.shape({
      dataKey: T.string,
      tickLine: T.bool,
      tick: T.object,
      color: T.string
    }), T.object]),
    yAxis: T.oneOfType([T.shape({
      dataKey: T.string,
      tickLine: T.bool,
      tick: T.object,
      color: T.string,
      axisLine: T.bool
    }), T.object]),
    lines: T.arrayOf(T.shape({
      dataKey: T.oneOfType([T.string, T.number, T.func]).isRequired,
      stroke: T.string,
      strokeDasharray: T.string,
      activeDot: T.oneOfType([T.bool, T.object, T.element, T.func])
    })).isRequired,
    titleString: T.string,
    titleId: T.string,
    dataMax: T.number,
    ticks: T.arrayOf(T.number),
    tickCount: T.number
  };
  static defaultProps = {
    height: CHART_HEIGHT,
    xAxis: {
      dataKey: 'name',
      tickLine: false,
      tick: {
        fill: XAXIS_FILL,
        opacity: 0.7,
        fontSize: 12,
        lineHeight: 17
      },
      color: XAXIS_COLOR
    },
    yAxis: {
      tickLine: false,
      tick: {
        fill: YAXIS_FILL,
        opacity: 0.6,
        fontSize: 12,
        lineHeight: 17
      },
      axisLine: false
    }
  };
  calcTickCount(max) {
    if (!max) {
      return [null, null, null];
    }
    const {
      tickCount,
      ticks
    } = this.props;
    if (tickCount && ticks) {
      return [tickCount, ticks[-1], ticks];
    }
    let tickC = 4;
    let yMax = max;
    let tick = [];
    if (ticks) {
      tickC = ticks.length;
      return [ticks, tickC];
    }
    if (tickCount) {
      tickC = tickCount;
    } else {
      yMax = Math.ceil(max / 4) * 4;
    }
    let val = 0;
    for (let i = 0; i <= tickC; i++) {
      tick.push(val);
      val += yMax / tickC;
    }
    return [tickC + 1, yMax, tick];
  }
  renderLines() {
    const {
      lines,
      dataMax
    } = this.props;
    let chartLines = [];
    for (let j = 0; j < lines.length; j++) {
      let axisId = 'left';
      if (j % 2 === 1) {
        axisId = 'right';
      }
      const line = /*#__PURE__*/_react.default.createElement(_recharts.Line, (0, _extends2.default)({
        key: lines[j].dataKey,
        yAxisId: dataMax ? axisId : undefined
      }, lines[j]));
      chartLines.push(line);
    }
    return chartLines;
  }
  render() {
    const {
      data,
      height,
      width,
      dataMax,
      titleString,
      titleId
    } = this.props;
    const xAxisProps = this.props.xAxis;
    const yAxisProps = this.props.yAxis;
    const [tickCount, yMax, ticks] = this.calcTickCount(dataMax);
    return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
      className: styles.container,
      width: width,
      height: height
    }, /*#__PURE__*/_react.default.createElement(_recharts.LineChart, {
      data: data,
      width: width - OFFSET,
      height: height - OFFSET,
      margin: {
        top: 104,
        right: 32,
        left: 0,
        bottom: 40
      }
    }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("foreignObject", {
      x: 32,
      y: 32,
      width: 194,
      height: 32
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.title,
      displayString: titleString,
      displayId: titleId
    }))), /*#__PURE__*/_react.default.createElement(_recharts.XAxis, xAxisProps), dataMax && /*#__PURE__*/_react.default.createElement(_recharts.YAxis, (0, _extends2.default)({
      domain: [0, yMax],
      ticks: ticks,
      tickCount: tickCount,
      yAxisId: "right",
      orientation: "right"
    }, yAxisProps)), dataMax && /*#__PURE__*/_react.default.createElement(_recharts.YAxis, (0, _extends2.default)({
      domain: [0, yMax],
      ticks: ticks,
      tickCount: tickCount,
      yAxisId: "left",
      orientation: "left"
    }, yAxisProps)), !dataMax && /*#__PURE__*/_react.default.createElement(_recharts.YAxis, (0, _extends2.default)({
      tickLine: false
    }, yAxisProps)), /*#__PURE__*/_react.default.createElement(_recharts.CartesianGrid, {
      vertical: false
    }), /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
      content: /*#__PURE__*/_react.default.createElement(CustomTooltip, null)
    }), this.renderLines()));
  }
}
exports.default = LineChart;